import React from 'react';
import { SearchDialogWrapper } from './search-dialog.styled';
export var SearchDialog = function SearchDialog(_ref) {
  var children = _ref.children,
    style = _ref.style,
    shouldFillContainer = _ref.shouldFillContainer,
    isExpanded = _ref.isExpanded;
  return /*#__PURE__*/React.createElement(SearchDialogWrapper, {
    shouldFillContainer: shouldFillContainer,
    isExpanded: isExpanded,
    "data-test-id": "search-dialog-dialog-wrapper",
    tabIndex: -1
    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
    ,
    style: style
  }, children);
};